import { Alert } from "antd";

function CommingSoon() {
  return <Alert style={{ textAllign: "center", margin: "50px 0", fontSize : "30px" }} message="Coming soon....." />;
}

export default CommingSoon;
